import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  Checkbox,
  Grid,
  Tooltip,
  Table,
  TableRow,
  TableCell,
  Button,
  Divider,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import usePageTitle from "app/pageTitle";
import { useAuthUser } from "react-auth-kit";

import MDInput from "theme/components/MDInput";
import MDButton from "theme/components/MDButton";
import DataTable from "theme/Tables/DataTable";
import axios from "axios.js";
import AgentGroupCard from "app/campaigns/components/agent_groups";
import PricePlansCard from "app/campaigns/components/pricing";
import CampaignLocationsCard from "app/campaigns/components/campaign_locations";
import CampaignViewsCard from "app/campaigns/components/campaign_view";

function PSAManagePage() {
  const pageTitle = "Product Sampling Campaign";
  usePageTitle(pageTitle);
  const navigate = useNavigate();
  const { ref } = useParams();
  const auth = useAuthUser();
  const accountInfo = auth();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };
  const [refreshPage, setRefreshPage] = useState(false);
  const [pageLoaded, setPageLoaded] = useState(false);
  function triggerRefresh() {
    setRefreshPage((prev) => !prev);
  }

  const [resultData, setResultData] = useState({});
  const [campaign, setCampaign] = useState({});
  const [products, setProducts] = useState([]);
  const [campaignTitle, setCampaignTitle] = useState(null);
  const [campaignFeedbackWindow, setCampaignFeedbackWindow] = useState(null);
  const [campaignReminderDelay, setCampaignReminderStartDelay] = useState(null);
  const [campaignReminderFrequency, setCampaignReminderFrequency] = useState(null);
  const [campaignReminderMessage, setCampaignReminderMessage] = useState(null);
  const [campaignAgentEscalation, setCampaignAgentEscalation] = useState(null);

  const [productTitle, setProductTitle] = useState(null);
  const [productPrice, setProductPrice] = useState(null);
  const [productQuantity, setProductQuantity] = useState(null);
  const [productSampleQuantity, setProductSampleQuantity] = useState(null);
  const [productImage, setProductImage] = useState(null);

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productAction, setProductAction] = useState("create");
  const [openAddProductDialog, setOpenAddProductDialog] = useState(false);

  const [dataForms, setDataForms] = useState([]);
  const [activationDataForms, setActivationDataForms] = useState([]);
  const [selectedDataForm, setSelectedDataForm] = useState(null);
  const [selectedDataFormType, setSelectedDataFormType] = useState(null);
  const [openAttachDataFormDialog, setOpenAttachDataFormDialog] = useState(false);

  async function deleteProduct(reference) {
    setShowLoading(true);
    await axios
      .get(`portal/psa/products/${reference}/delete.json`)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const productsTableColumns = [
    { Header: "Name", accessor: "title", align: "left" },
    { Header: "Price", accessor: "price", align: "left" },
    { Header: "Stock Quantity", accessor: "qty", align: "left" },
    { Header: "Sample Quantity", accessor: "s_qty", align: "left" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        title: row.title,
        price: row.price / 100,
        qty: row.quantity,
        s_qty: row.sample_quantity,
        actions: (
          <MDBox mt={1} variant="button">
            <Tooltip title="Edit">
              <MDButton
                size="small"
                variant="outlined"
                color="warning"
                iconOnly
                onClick={() => {
                  setProductTitle(row.title);
                  setProductSampleQuantity(row.sample_quantity);
                  setProductQuantity(row.quantity);
                  setProductPrice(row.price / 100);

                  setSelectedProduct(row.reference);
                  setProductAction("edit");
                  setOpenAddProductDialog(true);
                }}
              >
                <Icon sx={{ cursor: "pointer" }} fontSize="small">
                  edit
                </Icon>
              </MDButton>
            </Tooltip>
            &nbsp;
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Delete?`) === true) {
                  deleteProduct(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`/portal/psa/${ref}/fetch.json`)
        .then((result) => {
          // console.log(result.data.data.campaign.activation);
          setShowLoading(false);
          if (result.data.status === "success") {
            setResultData(result.data.data.campaign.campaign);
            setCampaign(result.data.data.campaign.activation);
            setCampaignTitle(result.data.data.campaign.activation.title);
            setCampaignFeedbackWindow(result.data.data.campaign.activation.feedback_window);
            setCampaignReminderMessage(result.data.data.campaign.activation.reminder_message);
            setCampaignReminderFrequency(result.data.data.campaign.activation.reminder_frequency);
            setCampaignReminderStartDelay(
              result.data.data.campaign.activation.reminder_start_delay
            );
            setCampaignAgentEscalation(
              result.data.data.campaign.activation.agent_escalation_trigger
            );

            const rows = buildRows(result.data.data.products);
            setProducts(rows);

            setDataForms(result.data.data.data_forms);
            const rowsD = buildCampaignDataFormsRows(result.data.data.activation_data_forms);
            setActivationDataForms(rowsD);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function updateCampaign() {
    if (campaignTitle === null) {
      setSeverity("error");
      setErrMsg("Campaign name is invalid.");
      setOpen(true);
      return;
    }

    if (campaign.is_instant_feedback) {
      if (campaignReminderMessage === null) {
        setSeverity("error");
        setErrMsg("Reminder message required.");
        setOpen(true);
        return;
      }
      if (campaignReminderFrequency === null) {
        setSeverity("error");
        setErrMsg("Reminder message frequency required.");
        setOpen(true);
        return;
      }
      if (campaignReminderDelay === null) {
        setSeverity("error");
        setErrMsg("Reminder message start delay required.");
        setOpen(true);
        return;
      }
    }

    setShowLoading(true);

    const json = {
      reference: ref,
      title: campaignTitle,
      feedback_window: campaignFeedbackWindow,
      reminder_message: campaignReminderMessage,
      reminder_start_delay: campaignReminderDelay,
      reminder_frequency: campaignReminderFrequency,
      agent_escalation_trigger: campaignAgentEscalation,
    };

    await axios
      .post(`portal/psa/update.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function createProduct() {
    if (productTitle === null) {
      setSeverity("error");
      setErrMsg("Product name is invalid.");
      setOpen(true);
      return;
    }

    if (productPrice === null) {
      setSeverity("error");
      setErrMsg("Product price is invalid.");
      setOpen(true);
      return;
    }

    if (productSampleQuantity === null) {
      setSeverity("error");
      setErrMsg("Product sample quantity is required");
      setOpen(true);
      return;
    }

    setOpenAddProductDialog(false);
    setShowLoading(true);

    let json = {
      reference: ref,
      title: productTitle,
      price: parseFloat(productPrice, 10) * 100,
      sample_quantity: productSampleQuantity,
      quantity: productQuantity,
    };
    let url = "create";

    if (productAction === "create") {
      json["reference"] = ref;
    } else {
      json["reference"] = selectedProduct;
      url = "update";
    }

    await axios
      .post(`portal/psa/products/${url}.json`, json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          setRefreshPage(!refreshPage);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function removeDataForm(formRef) {
    setShowLoading(true);
    await axios
      .get(`/portal/psa/data_forms/${formRef}/remove.json`)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          triggerRefresh();
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  async function attachDataForm() {
    if (selectedDataForm === null) {
      setSeverity("error");
      setErrMsg("Select a data form");
      setOpen(true);
      return;
    }

    setOpenAttachDataFormDialog(false);
    setShowLoading(true);
    const json = {
      reference: ref,
      form: selectedDataForm,
      type: selectedDataFormType,
    };

    await axios
      .post("portal/psa/data_forms/attach.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setSeverity("success");
          setErrMsg(result.data.data.message);
          setOpen(true);

          triggerRefresh();
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  const campaignDataFormsTableColumns = [
    { Header: "Data Form", accessor: "data_form", align: "left" },
    { Header: "Event", accessor: "type", align: "right" },
    { Header: "Actions", accessor: "actions", align: "right" },
  ];

  const buildCampaignDataFormsRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        data_form: row.title,
        type: row.type,
        actions: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="outlined"
              color="error"
              iconOnly
              onClick={() => {
                if (window.confirm(`Remove data form?`) === true) {
                  removeDataForm(row.reference);
                }
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                delete
              </Icon>
            </MDButton>
          </MDBox>
        ),
      });
      return null;
    });

    return rows;
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openAttachDataFormDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>Attach Data Form</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={2}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Data Form</InputLabel>
                <Select
                  label="Data Form"
                  onChange={(e) => {
                    setSelectedDataForm(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  {
                    // --> Notice below changes
                    dataForms.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                      dataForms.map((record) => (
                        <MenuItem value={`${record.reference}`}>{record.title}</MenuItem>
                      ))
                  }
                </Select>
              </FormControl>
            </MDBox>
            <MDBox mt={3}>
              <FormControl sx={{ minWidth: 120, width: "100%" }}>
                <InputLabel>Event</InputLabel>
                <Select
                  label="Event"
                  onChange={(e) => {
                    setSelectedDataFormType(e.target.value);
                  }}
                  sx={{ padding: "12px", paddingLeft: "3px" }}
                >
                  <MenuItem value="SAMPLE">At Sampling</MenuItem>
                  <MenuItem value="FEEDBACK">At Feedback</MenuItem>
                </Select>
              </FormControl>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAttachDataFormDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              attachDataForm();
            }}
          >
            Attach
          </MDButton>
        </DialogActions>
      </Dialog>
      <Dialog open={openAddProductDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <MDBox>{productAction === "create" ? "Create" : "Edit"} Product</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox sx={{ marginTop: "15px" }}>
            <MDBox mt={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Product Name"
                type="text"
                fullWidth
                variant="outlined"
                value={productTitle}
                onChange={(e) => setProductTitle(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Product Price"
                type="text"
                fullWidth
                variant="outlined"
                value={productPrice}
                onChange={(e) => setProductPrice(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Total Stock Quantity (Optional)"
                type="number"
                fullWidth
                variant="outlined"
                value={productQuantity}
                onChange={(e) => setProductQuantity(e.target.value)}
              />
            </MDBox>
            <MDBox mt={2}>
              <MDInput
                name="title"
                margin="dense"
                label="Sample Quantity"
                type="number"
                fullWidth
                variant="outlined"
                value={productSampleQuantity}
                onChange={(e) => setProductSampleQuantity(e.target.value)}
              />
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenAddProductDialog(false);
            }}
            color="dark"
            variant="outlined"
          >
            Cancel
          </MDButton>
          <MDButton
            color="dark"
            variant="contained"
            onClick={() => {
              createProduct();
            }}
          >
            {productAction === "create" ? "Add" : "Update"}
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox mb={5}>
        {pageLoaded && (
          <MDBox>
            <MDBox mt={1} mb={2} display="flex" justifyContent="space-between">
              <MDBox>
                <Button
                  color="dark"
                  size="small"
                  startIcon={<Icon>west</Icon>}
                  onClick={() => {
                    navigate(`/trade-marketing/promotions/product-sampling`);
                  }}
                >
                  Back
                </Button>
              </MDBox>
              <MDBox>
                <Button
                  size="small"
                  color="info"
                  iconOnly
                  onClick={() => {
                    navigate(`/trade-marketing/promotions/product-sampling/sample-records/${ref}`);
                  }}
                  startIcon={
                    <Icon sx={{ cursor: "pointer" }} fontSize="small">
                      people
                    </Icon>
                  }
                >
                  Samplings
                </Button>
                &nbsp;
                <Button
                  size="small"
                  color="info"
                  iconOnly
                  onClick={() => {
                    navigate(`/trade-marketing/promotions/product-sampling/feedbacks/${ref}`);
                  }}
                  startIcon={
                    <Icon sx={{ cursor: "pointer" }} fontSize="small">
                      rate_review
                    </Icon>
                  }
                >
                  Feedbacks
                </Button>
                &nbsp;
                <Button
                  size="small"
                  color="info"
                  iconOnly
                  onClick={() => {
                    navigate(`/trade-marketing/promotions/product-sampling/insights/${ref}`);
                  }}
                  startIcon={
                    <Icon sx={{ cursor: "pointer" }} fontSize="small">
                      leaderboard
                    </Icon>
                  }
                >
                  Insights
                </Button>
              </MDBox>
            </MDBox>
            <MDBox mt={1}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={7} lg={7}>
                  <Card>
                    <MDBox p={2}>
                      <MDBox>
                        <MDTypography variant="h6">
                          Activation Information
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDInput
                          value={campaignTitle}
                          name="title"
                          margin="dense"
                          label="Campaign Name"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setCampaignTitle(e.target.value)}
                        />
                      </MDBox>
                      {!campaign.is_instant_feedback && (
                        <MDBox mt={4}>
                          <MDInput
                            value={campaignFeedbackWindow}
                            name="title"
                            margin="dense"
                            label="Feedback Wait Time (days)"
                            type="number"
                            fullWidth
                            variant="outlined"
                            onChange={(e) => setCampaignFeedbackWindow(e.target.value)}
                          />
                          {/* <MDBox mb={1} align="center">
                            <MDTypography variant="subtitle2" fontSize={13} fontWeight="regular">
                              Configure Automated Feedback Collection
                            </MDTypography>
                            <Divider />
                          </MDBox>
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                value={campaignFeedbackWindow}
                                name="title"
                                margin="dense"
                                label="Feedback Window"
                                type="number"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => setCampaignFeedbackWindow(e.target.value)}
                              />
                            </Grid>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                value={campaignReminderFrequency}
                                name="title"
                                margin="dense"
                                label="Reminder Frequency"
                                type="number"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => setCampaignReminderFrequency(e.target.value)}
                              />
                            </Grid>
                          </Grid>
                          <Grid mt={0.5} container spacing={3}>
                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                value={campaignReminderDelay}
                                name="title"
                                margin="dense"
                                label="Reminder Start Delay"
                                type="number"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => setCampaignReminderStartDelay(e.target.value)}
                              />
                            </Grid>

                            <Grid item xs={12} md={6} lg={6}>
                              <MDInput
                                value={campaignAgentEscalation}
                                name="title"
                                margin="dense"
                                label="Trigger Agent Calling"
                                type="number"
                                fullWidth
                                variant="outlined"
                                onChange={(e) => setCampaignAgentEscalation(e.target.value)}
                              />
                            </Grid>
                          </Grid> */}
                          {/* <MDBox mt={2}>
                            <MDInput
                              value={campaignReminderMessage}
                              name="title"
                              margin="dense"
                              label="Reminder Message"
                              type="text"
                              multiline
                              minRows={3}
                              fullWidth
                              variant="outlined"
                              onChange={(e) => setCampaignReminderMessage(e.target.value)}
                            />
                          </MDBox> */}
                        </MDBox>
                      )}

                      <MDBox mt={5} mb={3} align="right">
                        <MDButton variant="contained" color="dark" onClick={() => updateCampaign()}>
                          Save Changes
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
                <Grid item xs={12} md={5} lg={5}>
                  <Card>
                    <MDBox p={2}>
                      <MDBox>
                        <MDTypography variant="h6">Quick Guide</MDTypography>
                      </MDBox>
                      <MDBox mt={1} px={2}>
                        <MDTypography variant="subtitle2" fontSize={14}>
                          <ol>
                            <li>
                              Add products to be sampled. Set total stock quantity and quantity
                              allowed per sampling.
                            </li>
                            <li>Set up geo-fencing. Restrict sampling to specific locations.</li>
                            <li>
                              Group and assign agents to this campaign. Go to team management to add
                              your agents.
                            </li>
                            {/* <li>
                              Optionally, you can work with supervisors, and have their agents
                              participate in this campaign.
                            </li> */}

                            {accountInfo.account.plan.code === "PAG" && (
                              <li>Activate this campaign and monitor results.</li>
                            )}
                          </ol>
                          <br />
                          {campaign.is_instant_feedback === false && (
                            <>
                              <MDBox>
                                <b>Feedback Wait Time:</b>
                                <br />
                                Duration in days the customer will have to sample the product before
                                the system prompts customer for feedback.
                              </MDBox>
                              {/* <ul>
                                <li>
                                  <b>Feedback Window:</b>
                                  <br />
                                  Duration in days the customer will have to sample the product and
                                  give feedback
                                </li>
                                <li>
                                  <b>Reminder Frequency:</b>
                                  <br />
                                  Set how frequent in days the system will prompt the customer to
                                  give feedback.
                                </li>
                                <li>
                                  <b>Reminder Start Delay:</b>
                                  <br />
                                  Days to wait before the system starts prompting the customer for
                                  feedback.
                                </li>
                                <li>
                                  <b>Trigger Agent Calling:</b>
                                  <br />
                                  Days to wait before agents can start calling customers to give
                                  feedback. action.
                                </li>
                              </ul> */}
                            </>
                          )}
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
              </Grid>
            </MDBox>
            <MDBox mt={3}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={2}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDBox>
                        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
                          Products
                        </MDTypography>
                      </MDBox>
                      <MDBox>
                        <MDButton
                          variant="contained"
                          color="dark"
                          iconOnly
                          onClick={() => {
                            setProductTitle(null);
                            setProductSampleQuantity(null);
                            setProductQuantity(null);
                            setProductPrice(null);

                            setProductAction("create");
                            setOpenAddProductDialog(true);
                          }}
                        >
                          <Icon>add</Icon>
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                  <MDBox p={0}>
                    <DataTable
                      table={{ columns: productsTableColumns, rows: products }}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries
                      buttons
                      noEndBorder
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>

            <MDBox>
              <CampaignLocationsCard
                campaignRef={ref}
                campaignLocations={resultData.campaign_locations}
                triggerRefresh={triggerRefresh}
              />
            </MDBox>
            <MDBox mt={3}>
              <Card sx={{ height: "100%", marginTop: "0px" }}>
                <MDBox>
                  <MDBox p={2}>
                    <MDBox display="flex" justifyContent="space-between" alignItems="center">
                      <MDTypography variant="h6" fontWeight="light">
                        <b>Data Form</b>
                        <br />
                        <small>
                          Capture required information during a sampling or feedback event. Attach a
                          data form.
                        </small>
                      </MDTypography>
                      <MDButton
                        variant="contained"
                        color="dark"
                        iconOnly
                        onClick={() => {
                          setSelectedDataForm(null);
                          setOpenAttachDataFormDialog(true);
                        }}
                      >
                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                      </MDButton>
                    </MDBox>
                  </MDBox>
                  <MDBox mb={3}>
                    <DataTable
                      table={{ columns: campaignDataFormsTableColumns, rows: activationDataForms }}
                      isSorted
                      entriesPerPage={false}
                      showTotalEntries={false}
                      buttons
                      noEndBorder
                      canSearch={false}
                    />
                  </MDBox>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox>
              <AgentGroupCard
                campaignRef={ref}
                agentGroups={resultData.agent_groups}
                campaignAgentGroups={resultData.super_agents}
                aggregators={resultData.aggregators}
                campaignAggregators={resultData.campaign_aggregators}
                triggerRefresh={triggerRefresh}
              />
            </MDBox>
            <MDBox mt={3}>
              <CampaignViewsCard
                campaignRef={ref}
                triggerRefresh={triggerRefresh}
                campaignViews={resultData.campaign_views}
              />
            </MDBox>
            {accountInfo.account.plan.code === "PAG" && (
              <MDBox mt={3}>
                <PricePlansCard
                  campaignRef={ref}
                  triggerRefresh={triggerRefresh}
                  packages={resultData.packages}
                  campaignPackage={resultData.campaign_package}
                  campaignType={campaign.campaign_type}
                  currency={resultData.currency}
                />
              </MDBox>
            )}
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default PSAManagePage;
